import { useState } from 'react';

import { Button } from '@hivebrite/design-system/Button';
import { toast } from '@hivebrite/design-system/Toast';

import { useMentorshipsContext } from 'hb-react/frontoffice/apps/Mentorships/contexts/MentorshipsContext';
import { getMentorLabel } from 'hb-react/frontoffice/apps/Mentorships/utils';
import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { updateMentorProfiles } from 'hb-react/shared/apps/Mentorships/utils/mentorProfiles';
import ModalWithTemplate from 'hb-react/shared/components/DesignSystem/Modal/ModalWithTemplate';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

import ApplyToBeMentorForm from '../Forms/ApplyToBeMentorForm';

const ApplyToBeMentorModal = ({ customAttributesList, isPreview }) => {
  const { currentUser, updateCurrentUser, currentNetwork } =
    useDefaultAppContexts();

  const mentorshipsContext = useMentorshipsContext();

  const mentorLabel =
    mentorshipsContext?.mentorLabel ?? getMentorLabel(currentNetwork);

  const applyText = s__('Mentorships|Apply to be %{mentorLabel}').i__({
    mentorLabel: mentorLabel.toLowerCase(),
  });
  const { topicId } = useTopicContext();

  const [isOpen, setOpen] = useState(false);

  const onCloseModal = () => {
    setOpen(false);
  };

  const onOpenModal = () => {
    setOpen(true);
  };

  const mentorsPath = topicId
    ? Routes.topics_topic_mentors_path(topicId)
    : Routes.mentorships_mentors_path();

  const onSubmit = (values) => {
    axios
      .post(mentorsPath, values)
      .then((response) => {
        toast.success(
          s__('Mentorships|Your request has been taken into account'),
        );

        currentUser.current_mentor_profiles = updateMentorProfiles({
          mentorProfiles: currentUser.current_mentor_profiles,
          profile: response.data.mentor,
        });

        // This triggers a re-processing of getMentorshipsHeaderControls
        // which will unmount this component so we don't need to (and must not)
        // use onCloseModal or we will trigger a "Can't perform a React state
        // update on an unmounted component." error.
        updateCurrentUser(currentUser);
      })
      .catch(() => {
        toast.error(__('Sorry, an error occurred'));
      });
  };

  return (
    <>
      <Button onClick={isPreview ? undefined : onOpenModal}>{applyText}</Button>
      {isOpen && (
        <ModalWithTemplate
          onCloseModal={onCloseModal}
          header={applyText}
          screenReadersCloseButtonText={s__(
            'Accessibility|Close the apply to be a %{mentorLabel} window',
          ).i__({
            mentorLabel: mentorLabel.toLowerCase(),
          })}
        >
          <ApplyToBeMentorForm
            onSubmit={onSubmit}
            onCancel={onCloseModal}
            customAttributesList={customAttributesList}
          />
        </ModalWithTemplate>
      )}
    </>
  );
};

export default ApplyToBeMentorModal;
